import { computed, watch } from 'vue'
import store from '../store'

export const useFeedbackButtonVisibility = () => {
  const currentTab = computed(() => store.state.comment.currentTab)
  const dikeProfilesLoaded = computed(() => store.state.dikeProfiles.loaded)
  const dikeSectionLoaded = computed(() => store.state.dikeSection.loaded)
  const referencePointLoaded = computed(() => store.state.referencePoint.loaded)

  const dikeTrajectImported = computed(() => {
    return dikeProfilesLoaded.value && referencePointLoaded.value && dikeSectionLoaded.value
  })

  const toggleFeedbackButton = () => {
    const shouldShift = currentTab.value?.model === 'dikesection' && !dikeTrajectImported.value
    const feedbackActor = document.getElementById('sentry-feedback')
    feedbackActor?.style.setProperty('--actor-inset', shouldShift ? 'auto 0 40px auto' : '')
  }

  watch(currentTab, toggleFeedbackButton, { immediate: true })
  watch(dikeTrajectImported, toggleFeedbackButton)

  return { toggleFeedbackButton }
}
